/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate")

package js.features.userBusinessCoupons

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.promise
import kotlin.js.Promise
import kotlinx.serialization.json.Json
import features.userBusinessCoupons.UserBusinessCouponsApi
import features.userBusinessCoupons.models.UserBusinessCouponsModel
import features.userBusinessCoupons.serializeUserBusinessCouponsState



/**
 * Get a list of available coupons for this user for a specific business. [Api] class
 */
@OptIn(DelicateCoroutinesApi::class)
@ExperimentalJsExport
@JsExport
@JsName("UserBusinessCouponsApi")
class UserBusinessCouponsApiJs {

    /**
     * Get a list of available coupons for this user for a specific business.
     */
    fun getUserBusinessCoupons(
        overrideHeaders: String?, 
        businessId: String
    ): Promise<String?>  {
        return GlobalScope.promise {

        val decodedOverrideHeaders = if (overrideHeaders == null) {
                null
        } else {
            try {
                Json.decodeFromString<Map<String, String>>(overrideHeaders)
            } catch (e: Exception) {
                null
                }
            }

            val result = UserBusinessCouponsApi().getUserBusinessCoupons(
            overrideHeaders = decodedOverrideHeaders,
                        businessId = businessId
        ).toJsonResult<UserBusinessCouponsModel>()
        
            return@promise when (result) {
                is SerializedResult.Success -> result.data
                is SerializedResult.UnauthorizedError -> result.error
                is SerializedResult.UnknownError -> result.error
                else -> null
            }
        }
    }

    

    

    fun observeUserBusinessCouponsState(
        onData: (String) -> Unit,
        onStreamError: (String) -> Unit,
    ) {
        UserBusinessCouponsApi().userBusinessCouponsState.serializeUserBusinessCouponsState().observe { result ->
            when (result) {
                is SerializedResult.Idle -> onData(result.state)
                is SerializedResult.Loading -> onData(result.state)
                is SerializedResult.Success -> onData(result.data)
                is SerializedResult.UnauthorizedError -> onData(result.error)
                is SerializedResult.UnknownError -> onData(result.error)
                else -> onStreamError("unknown error in stream")
            }
        }
    }
}
